import { RechercheService } from './../Service/recherche.service';
import { Global } from 'src/app/Service/global.service';
import { Component, OnInit } from '@angular/core';
import { takeUntil } from 'rxjs/operators';
import { forkJoin } from 'rxjs';
import { sp, Web} from "@pnp/sp/presets/all";

@Component({
  selector: 'app-search-config',
  templateUrl: './search-config.component.html',
  styleUrls: ['./search-config.component.scss'],
})
export class SearchConfigComponent implements OnInit {
  showItem = false;
  modalTitle = '';
  currentLg = '';
  contenus = [];
  listeParams = [];
  contenuSets = [];
  contenuNotSets = [];
  currentFields = [];
  selectedList= 0;
  currentList = null;
  selectedListTitle = '';
  currentDescription = '';
  currentTitle = '';
  currentRecherche = [];
  currentConfig = null;
  constructor(private global: Global, private service: RechercheService) {
    sp.setup({
      sp:{
        baseUrl: this.global._basedUrl
      }
    })
  }

  ngOnInit(): void {
    this.global.CurentLanguage.pipe(
      takeUntil(this.global.navigationEnd)
    ).subscribe((lg) => {
      this.listeParams = [];
      this.currentLg = lg.code.toUpperCase();
      forkJoin([
        this.service.getParamRecherche(),
        this.service.getRechercheContenu(),
      ]).subscribe((datas) => {
        //@ts-ignore
        this.contenus = datas[1].value;
          //@ts-ignore
        datas[0].value.forEach(element => {
          const item = this.getContenuById(element.ListeId);
          this.contenuSets.push(element.ListeId);
        const obj = {
          Title: item.Title,
          InternalName: item.InternalName,
          TypeListe : item.TypeListe,
          ApplicationUrl: item.ApplicationUrl,
          Langue : item.Langue,
          Ports: item.Ports, 
          Champs: element.ChampsRecherchable!== null && element.ChampsRecherchable!== '' ? element.ChampsRecherchable.split(',') : '', 
          ResultsTitre:element.TitreResult,
          ResultsDescription:element.DescriptionResult,
          Id: element.Id, 
          IdContenu: element.ListeId
        }
        this.listeParams.push(obj);
          
        });
        this.contenus.forEach(element=> {
          if(this.contenuSets.indexOf(element.Id) === -1) {
            this.contenuNotSets.push(element);
          }
        });
        // console.log(this.contenuNotSets);
      });
    });
  }

  getContenuById(id) {
    let obj = null;
    this.contenus.forEach(item => {
      if(id === item.Id) {
        obj = {
          Title : item.Title,
          InternalName: item.InternalName,
          TypeListe : item.TypeListe,
          ApplicationUrl: item.ApplicationUrl,
          Langue : item.Langue,
          Ports: item.Ports, 
        }
      }
    });
    return obj
  }
  resetModal() {
    this.currentList = null;
    this.currentFields = []
    this.currentDescription = '';
    this.currentTitle = '';
    this. currentRecherche = [];
    this.selectedListTitle = '';
    this.selectedList = 0;
  }
  getFieldsList(item=0) { 
   debugger;
    item =item === 0?  +this.selectedList : item
    this.resetModal();
   this.contenus.forEach(element => {
     if(element.Id === item) {
      this.currentList = element
     }
   });
   if(this.currentList!== null) {
     let url = ''
    const lg = this.currentList.Langue[0];
    if(lg === 'FR') {
      url = this.global._FrUrl
    } else if (lg === 'AR') {
      url = this.global._ArUrl
    }else  {
      url = this.global._EnUrl
    }
    if (this.currentList.Ports) {
        url =  '/Services/' + lg
       
    }
    this.currentFields = [];
    this.service.getFieldList(this.global._basedUrl + url, this.currentList.Title).subscribe(datas => {
      //@ts-ignore
      datas.value.forEach(element => {
        if((element.CanBeDeleted || element.InternalName === 'Title')&& ((element.TypeAsString === 'Text') 
        || (element.TypeAsString === 'Note') || (element.TypeAsString === 'Choice') )) {
          this.currentFields.push(element);
        }
      });
      // console.log(this.currentFields);
    })
   } 
  }
  SaveConfig() {
    if(this.currentList !== null && this.currentTitle !== '') {
      if(this.currentList.TypeListe === 'Liste') {
        if(this.currentRecherche.length ===0) {
          alert('Merci d\'ajouter des colonnes pour la recherche dans la liste ');
        } else {
               // console.log(formItems);
               let list =   sp.web.lists.getByTitle("RechercheParametres");
          if(this.currentConfig === null) {
           
       
                const obj = {
                  ListeId :  this.currentList.Id, 
                  ChampsRecherchable :this.returnStringFromTab( this.currentRecherche),
                  TitreResult : this.currentTitle,
                  DescriptionResult : this.currentDescription,
                };
              //  console.log(obj);
                list.items.add(obj).then(datas => {
                //  console.log(datas);
                alert('Votre config a bien été enregistrée !')
                  this.closeModal();
                  location.reload();
                });
          } else {
            const obj = {
              ChampsRecherchable : this.returnStringFromTab(this.currentRecherche),
              TitreResult : this.currentTitle,
              DescriptionResult : this.currentDescription,
            };
            list.items.getById(this.currentConfig.Id).update(obj).then(datas => {
              //  console.log(datas);
              alert('Votre config a bien été enregistrée !')
                this.closeModal();
                location.reload();
              });
          }
        }
      } else { // Bibliotheque 
                   // console.log(formItems);
                   let list =   sp.web.lists.getByTitle("RechercheParametres");
                   if(this.currentConfig === null) {
                         const obj = {
                           ListeId :  this.currentList.Id, 
                           TitreResult : this.currentTitle,
                           DescriptionResult : this.currentDescription,
                         };
                        // console.log(obj);
                         list.items.add(obj).then(datas => {
                         //  console.log(datas);
                         alert('Votre config a bien été enregistrée !')
                           this.closeModal();
                           location.reload();
                         });
                   } else {
                     const obj = {
                       TitreResult : this.currentTitle,
                       DescriptionResult : this.currentDescription,
                     };
                     list.items.getById(this.currentConfig.Id).update(obj).then(datas => {
                       //  console.log(datas);
                       alert('Votre config a bien été enregistrée !')
                         this.closeModal();
                         location.reload();
                       });
                   }
      }
    } else {
      alert('Merci de saisir les champs obligatoire')
    }
  }
  RemoveConfig(item) {
    let list =   sp.web.lists.getByTitle("RechercheParametres");
    list.items.getById(item.Id).delete().then(datas => {
      alert('Configuration Supprimé avec succès');
      location.reload();
    })
  }

  closeModal() {
    const btn = document.getElementById('closeModal');
    btn.click();
  }
  returnStringFromTab(tab) {
    let t = '';
    tab.forEach(element => {
      if(t !== '') {
        t = t +',' +element;
      } else {
        t=element
      }

    });
    return t
  }
  modifyConfig(item) {

    this.getFieldsList(item.IdContenu);
    this.selectedListTitle= item.Title
    this.selectedList = this.currentList.IdContenu,
    this.currentRecherche = item.Champs;
    this.currentTitle = item.ResultsTitre;
    this.currentDescription =item.ResultsDescription;
  }
}
